import React, { useContext, useState } from 'react';
import { Card, CardContent, CardHeader, makeStyles, Menu, MenuItem } from '@material-ui/core';
// import MORE_OPTIONS from '../../../assets/images/3-dots-horizontal.png';
import { Gender, Age } from '../../UI';
import { PropTypes } from 'prop-types';
import { getTime } from '../../../utils/dateTimeUtil';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import MessagesContext from '../../../contexts/messagesContext';
import LanguageContext from '../../../contexts/languageContext';
const withStyles = makeStyles(() => ({
    patientOverallInfo: {
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: (props) => (props.rtl ? 'row-reverse' : 'row')
    },
    patientInfo: {
        display: 'flex',
        color: '#767676'
    },
    cardRoot: (props) => ({
        // width: '100%',
        backgroundColor: '#ffffff',
        margin: '16px',
        borderRadius: '10px',
        padding: '8px 13px 14px',
        fontSize: '13px',
        color: '#636566',
        boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.12)',
        lineHeight: '1.8em',
        transform: props.isDragging ? 'rotate(-4deg)' : 'rotate(0)'
    }),
    draggingCardRoot: {
        width: '100%',
        margin: '6px 8px',
        borderRadius: '10px',
        padding: '8px 13px 14px',
        fontSize: '13px',
        color: '#636566',
        boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.12)',
        lineHeight: '1.8em'
    },
    titleHeader: {
        fontSize: '13px',
        color: '#636566',
        fontWeight: 'bold',
        maxWidth: '170px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    cardHeaderRoot: {
        padding: '0'
    },
    cardContent: {
        padding: '0',
        '&:last-child': {
            paddingBottom: '0'
        }
    },
    cardAction: {
        margin: '0'
    },
    optionIconContainer: {
        position: 'relative'
    },
    moreOptionIcon: {
        width: '24px',
        height: '24px',
        cursor: 'pointer'
    },
    timeSection: (props) => ({
        paddingTop: '18px',
        fontSize: '13px',
        color: '#767676',
        textAlign: props.rtl ? 'right' : 'left'
    }),
    timeItem: (props) => ({
        display: 'inline-block',
        textAlign: 'center',
        width: '25%',
        position: 'relative',
        '&:last-child:before, &:first-child:after': {
            content: '""',
            width: '0'
        },
        '&:before, &:after': {
            height: '2px',
            position: 'absolute',
            top: '30%',
            lineHeight: '1.2em',
            borderBottom: '2px dotted #998a8d',
            content: '""'
        },
        '&:before': {
            left: props.rtl ? '1px' : 'auto',
            right: props.rtl ? 'auto' : '1px',
            width: props.isDragging ? '0' : '4px'
        },
        '&:after': {
            right: props.rtl ? '1px' : 'auto',
            left: props.rtl ? 'auto' : '1px',
            width: props.isDragging ? '0' : '5px'
        },
        '& > span': {
            backgroundColor: props.isDragging ? '#eff6ff' : '#f5f7fa',
            borderRadius: '10px',
            padding: '3px 10px'
        }
    }),
    selectRoot: {
        padding: '0 !important',
        '&:focus': {
            background: 'none'
        }
    },
    inputRoot: {
        paddingRight: '0',
        position: 'absolute',
        left: '0',
        right: '0',
        top: '0',
        bottom: '0',
        '&:hover:before': {
            borderBottom: 'none !important'
        },
        '&:before, &:after': {
            borderBottom: 'none'
        }
    },
    selectIcon: {
        display: 'none'
    },
    genderIcon: {
        width: '24px',
        height: '24px'
    },
    linkContainer: {
        display: 'block',
        width: '100%'
    }
}));
const AppointmentCard = withRouter((props) => {
    const { messages } = useContext(MessagesContext);
    const { lang } = useContext(LanguageContext);
    const classes = withStyles({ ...props, rtl: lang === 'fa' });
    const options = [
        { label: messages.deleteAppointment, value: '0' },
        { label: messages.moveAppointmentTo, value: '1' },
        { label: messages.movePatientTo, value: '2' }
    ];
    const [anchorEl, setAnchorEl] = useState(null);
    const clinicId = props?.location?.pathname?.split('/').filter((item) => item)[0];
    const handleClose = (event) => {
        event.preventDefault();
        setAnchorEl(null);
    };
    // const toggleMenu = (event) => {
    //     event.preventDefault();
    //     setAnchorEl(event.currentTarget);
    // };
    if (!props.appointment) {
        return null;
    }
    return (
        <Link
            className={classes.linkContainer}
            to={`/${clinicId}/patient/${props.appointment.patient.id}/profile`}
        >
            <Card className={classes.cardRoot}>
                <CardHeader
                    classes={{ root: classes.cardHeaderRoot, action: classes.cardAction }}
                    // action={
                    //     <div
                    //         className={classes.optionIconContainer}
                    //         onClick={(event) => toggleMenu(event)}
                    //     >
                    //         <img className={classes.moreOptionIcon} src={MORE_OPTIONS} alt="more" />
                    //     </div>
                    // }
                    // title={
                    // }
                ></CardHeader>
                <CardContent className={classes.cardContent}>
                    <Menu open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={handleClose}>
                        {options.map((option, key) => (
                            <MenuItem onClick={handleClose} key={key} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </Menu>

                    {/* <div>{props.appointment.initial_complaint}</div> */}
                    <div className={classes.patientOverallInfo}>
                        <div className={classes.titleHeader}>
                            {props.appointment?.patient.first_name}{' '}
                            {props.appointment?.patient.last_name}
                        </div>
                        <div className={classes.patientInfo}>
                            {props.appointment?.patient?.dob && (
                                <Age dob={props.appointment?.patient?.dob} />
                            )}
                            {props.appointment?.patient?.gender && (
                                <Gender height="24" gender={props.appointment?.patient?.gender} />
                            )}
                        </div>
                    </div>
                    <div className={classes.timeSection}>
                        {props.appointment.appointed && (
                            <div className={classes.timeItem}>
                                <span>{getTime(props.appointment.appointed)}</span>
                            </div>
                        )}
                        {props.appointment.admitted && (
                            <div className={classes.timeItem}>
                                <span>{getTime(props.appointment.admitted)}</span>
                            </div>
                        )}
                        {props.appointment.entered && (
                            <div className={classes.timeItem}>
                                <span>{getTime(props.appointment.entered)}</span>
                            </div>
                        )}
                        {props.appointment.exited && (
                            <div className={classes.timeItem}>
                                <span>{getTime(props.appointment.exited)}</span>
                            </div>
                        )}
                    </div>
                </CardContent>
            </Card>
        </Link>
    );
});
AppointmentCard.propTypes = {
    appointment: PropTypes.any,
    isDragging: PropTypes.any,
    match: PropTypes.any
};
export default AppointmentCard;
